import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsExternalNetworksAdminPageEnabled = () => boolean;
export const useIsExternalNetworksAdminPageEnabled: UseIsExternalNetworksAdminPageEnabled = () => {
  const experimentValue = useExperimentTreatmentWithoutReporting('ExternalNetworksAdminPage') as number;

  return experimentValue > 0;
};
